import React, { useCallback, useState } from 'react';
import { Modal, ModalTitle, FieldLabel, SelectInput, FormButton, FieldHelperText } from '@td/ui';
import { Formik, ErrorMessage, Form } from 'formik';
import { EditIcon } from '../../icons';
import toastr from '../../toastr';
import { useNpCoordination } from '../context/NpCoordinationContext';
import { createOrUpdateProviderRelation } from '../api/createOrUpdateProviderRelation';
import queryCollaboratingPhysicians from '../api/collaboratingPhysicians';
import { validationSchema } from '../validations';
import { mapToProviderToDropdownOption } from '../utils';

const EditModal = ({ state, physicianId, supervisor }) => {
  const { filters, activePage, debouncedLoadItems } = useNpCoordination();
  const [isOpen, setIsOpen] = useState(false);
  const [collaboratingPhysicians, setCollaboratingPhysicians] = useState([]);
  const currentCP = supervisor ? mapToProviderToDropdownOption(supervisor): null;

  const getCollaboratingPhysicians = async () => {
    setCollaboratingPhysicians(
      await queryCollaboratingPhysicians(state)
    )
  }

  const handleSubmit = useCallback(async (values) => {
    const { value: collPhysicianId } = values.collPhysician;
    const { errors, success } = await createOrUpdateProviderRelation(collPhysicianId, physicianId, state);

    if (success) {
      toastr.success("Collaborating physician assigned successfully.");

      setIsOpen(false);
      debouncedLoadItems(filters, activePage);
    } else {
      toastr.error(
        errors[0] ? errors[0] : "An error occurred while assigning the collaborating physician."
      );
    }
  }, [physicianId]);

  return(
    <div>
      <a onClick={() => { setIsOpen(true); getCollaboratingPhysicians(); }}>
        <EditIcon height={12} width={12} fill="#000000" />
      </a>
      <Modal
        title="Manage Assignments"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <ModalTitle title="Manage Assignments" />
        <Formik
          initialValues={{collPhysician: currentCP}}
          validationSchema={validationSchema()}
          onSubmit={(values) => handleSubmit(values)}
        >
          {({ values, setFieldValue, handleSubmit }) => (
            <Form>
              <FieldLabel>
                Collaborating Physicians
                <SelectInput
                  value={values.collPhysician}
                  name="collPhysician"
                  onChange={cp => setFieldValue('collPhysician', cp)}
                  options={collaboratingPhysicians}
                />
                <ErrorMessage
                  name="collPhysician"
                  render={msg => <FieldHelperText error>{msg}</FieldHelperText>}
                />
              </FieldLabel>
              <FormButton type="submit" onClick={handleSubmit}>Save</FormButton>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  )
}

export default EditModal;
